import { setStyles } from '@/utils/customizing';

export default {
    computed: {
        customizing () {
            return this.$root.appConfig.customizing;
        },
    },
    watch: {
        customizing: {
            deep: true,
            handler () {
                setStyles(this.$root.id, this.$root.appConfig);
            },
        },
    },
};
